import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface GuardianEmailFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /**
   * False on a row a squad's team manager entered, which may carry no address
   * at all: the desk can add one, and is not made to.
   */
  required?: boolean;
}

/**
 * The parent's or guardian's address, asked for on an entry whose date of
 * birth is under 14. Required as a rule: below the consent age the child
 * cannot open an account, so this is the address the letter goes to — and the
 * organiser is expected to hold the guardian's written authorisation before
 * typing it. Not on a squad's entry (see `required`).
 */
export default function GuardianEmailField({ id, value, onChange, required = true }: GuardianEmailFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2 rounded-md border border-dashed p-3" data-testid="guardian-email-field">
      <Label htmlFor={id}>{t('gymAdmin.registrations.guardianEmail')}</Label>
      <Input id={id} type="email" value={value} onChange={(e) => onChange(e.target.value)} required={required} />
      <p className="text-xs text-muted-foreground">
        {required ? t('gymAdmin.registrations.guardianEmailHelp') : t('gymAdmin.registrations.teamEntryEmailHelp')}
      </p>
    </div>
  );
}
